import axios from "axios";
import config from "src/config";
import { ICreateContactsGroupRequest } from "src/pages/contact/interfaces";
import { ITalentContactGroupsResponse } from "src/pages/talent-hub/interfaces";
import {
  getJsonContentHeader,
  getAuthHeader,
  getAxiosOptions,
} from "../../headers";

const createContactsGroup = async (
  accessToken: string,
  createRequest: ICreateContactsGroupRequest,
  organisationId: string
): Promise<ITalentContactGroupsResponse> => {
  const options = {
    headers: { ...getAuthHeader(accessToken), ...getJsonContentHeader() },
    ...getAxiosOptions(),
  };

  const response = await axios.post(
    `${config.projectManagementService.url}/talent-hub/group?orgId=${organisationId}`,
    createRequest,
    options
  );

  return response.data as ITalentContactGroupsResponse;
};

export default createContactsGroup;
